import { render, staticRenderFns } from "./FiltroGerenciamentoToken.vue?vue&type=template&id=3c2ed2e8"
import script from "./FiltroGerenciamentoToken.vue?vue&type=script&lang=js"
export * from "./FiltroGerenciamentoToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports